import { PAGES } from '@ats/constants';
import IntervieweeAuthenticatedLayout from '@layout/Authenticated/Interviewee';
import ErrorLayout from '@layout/Error';
import InterviewLayout from '@layout/Interview';
import ModalLayout from '@layout/Modal';
import IntervieweeSettingLayout from '@layout/Setting/Interviewee';
import WaitingLayout from '@layout/Waiting';
import CheckBrowserPage from '@pages/CheckBrowser';
import CheckDevicePage from '@pages/CheckDevice';
import IntervieweeHomePage from '@pages/Interviewee/Home';
import IntervieweeRoomPage from '@pages/Interviewee/Room';
import IntervieweeSettingPage from '@pages/Interviewee/Setting';
import IntervieweeWaitingPage from '@pages/Interviewee/Waiting';
import type { RouteObject } from 'react-router';

const IntervieweeRoute: RouteObject = {
  path: PAGES.VIDEO_INTERVIEW.INTERVIEWEE.HOME,
  element: (
    <ModalLayout>
      <InterviewLayout />
    </ModalLayout>
  ),
  children: [
    {
      index: true,
      element: <IntervieweeHomePage />,
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWEE.WAITING,
      element: <WaitingLayout />,
      children: [
        {
          index: true,
          element: (
            <IntervieweeAuthenticatedLayout>
              <IntervieweeWaitingPage />
            </IntervieweeAuthenticatedLayout>
          ),
        },
      ],
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWEE.ROOM,
      element: (
        <IntervieweeAuthenticatedLayout>
          <IntervieweeRoomPage />
        </IntervieweeAuthenticatedLayout>
      ),
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWEE.SETTING,
      element: <IntervieweeSettingLayout />,
      children: [
        {
          index: true,
          element: <IntervieweeSettingPage />,
        },
      ],
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWEE.CHECK_BROWSER,
      element: <ErrorLayout />,
      children: [
        {
          index: true,
          element: <CheckBrowserPage />,
        },
      ],
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWEE.CHECK_DEVICE,
      element: <ErrorLayout />,
      children: [
        {
          index: true,
          element: <CheckDevicePage />,
        },
      ],
    },
  ],
};

export default IntervieweeRoute;
